import * as React from 'react'
import TableHead from './TableHead'
import ErrorMessage from '../job_plannings/list_app/ErrorMessage'
import TableDateGroup from './TableDateGroup'
import { DEFAULT_COLSPAN } from './TableDateGroupHeader'
import { ProductionPlanningLineShape } from '../../api/api_data_types'

type TableProps = {
  isLoading: boolean
  isError: boolean
  error?: any
  productionPlanningLines?: Record<string, ProductionPlanningLineShape[]>
  areas?: string[]
  showCompletedToday: boolean
  filter: any
  searchText: string
}

function matchesSearchText(productionPlanningLine: ProductionPlanningLineShape, normalizedSearchText: string) {
  if (!normalizedSearchText) return true

  const searchableFields = [
    productionPlanningLine.job_id,
    productionPlanningLine.order_number,
    productionPlanningLine.customer_title,
    productionPlanningLine.job_title,
  ]

  return searchableFields.some(field => String(field || '').toLowerCase().includes(normalizedSearchText))
}

export default function Table(props: TableProps) {
  const { isLoading, isError, productionPlanningLines, error, areas, showCompletedToday, filter, searchText } = props
  const hideItems = filter?.hide_items || false
  const normalizedSearchText = searchText.trim().toLowerCase()
  const groupedProductionPlanningLines = productionPlanningLines || {}
  const filteredProductionPlanningLines = Object.fromEntries(
    Object.entries(groupedProductionPlanningLines).map(([date, lines]) => {
      return [date, lines.filter(line => matchesSearchText(line, normalizedSearchText))]
    }),
  )

  return (
    <div>
      <table className="table table-print-sm">
        <TableHead hideItems={hideItems} showCompletedToday={showCompletedToday} />
        <tbody>
          {isLoading && (
            <tr>
              <td colSpan={DEFAULT_COLSPAN}>
                <div className="text-center">
                  <i className="fa fa-spinner fa-spin fa-2x" />
                </div>
              </td>
            </tr>
          )}
          {!isLoading &&
            Object.keys(filteredProductionPlanningLines).map(date => {
              const lines = filteredProductionPlanningLines[date]
              if (!lines.length) return null
              return (
                <TableDateGroup
                  key={date}
                  date={date}
                  hideItems={hideItems}
                  productionPlanningLines={lines}
                  areas={areas}
                  filter={filter}
                  showCompletedToday={showCompletedToday}
                />
              )
            })}
          {isError && (
            <tr>
              <td colSpan={DEFAULT_COLSPAN}>
                <ErrorMessage className="d-inline error-message" error={error} isError={isError} />
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  )
}
